
<template>
  <div class="w-full h-full flex flex-col bg-primary-700">
    <transition name="fade-75">
      <div @click="changePwdIsOpen=!changePwdIsOpen, mailsent=false" v-if="changePwdIsOpen == true" class="absolute h-full w-full bg-primary-900 opacity-75" style="z-index: 40;"></div>
    </transition>
    <transition name="fade-change-pwd">
      <div v-if="changePwdIsOpen == true" class="absolute-center flex flex-col lg:flex-row z-50">
        <!-- <div class="md:order-2">
          auwkeifg qwvekufigaervfukagwevfiauv
        </div> -->
        <div class="ml-4 mb-4 md:mb-0 lg:order-2" style="min-width:370px;">
          <h2 class="text-4xl text-light font-bold">
            Reestablecer contraseña
          </h2>
          <span class="h-1 bg-secondary w-20 inline-block" />
          <transition name="fade-up">
            <p  v-if="!mailsent" class="text-lg mt-2 text-primary-100">Introduce una contraseña que contenga al menos 8 caracteres con números y letras</p>
          <!-- Este texto hay que revisarlo y la condición a cumplir es inventada (pendiente de definir) -->
          </transition>
        </div>
        <div class="lg:order-1 w-full max-w-sm px-2" style="min-width:370px;">
          <div v-if="!mailsent" class="w-full bg-primary-800 p-6 rounded-lg border border-solid border-primary-200">
            <Input class="mb-2" id="npwd" placeholder="Nueva contraseña…" v-model="npwd"/>
            <Input class="mb-4" id="cnpwd" placeholder="Confirmar nueva contraseña…" v-model="cnpwd"/>
            <div>
              <p v-if="errorlen" class="text-sm mt-2 text-primary-100"><span style="color:red">* </span>Introduce una contraseña que contenga al menos 8 carácteres</p>
              <p v-if="errorpwddif" class="text-sm mt-2 text-primary-100"><span style="color:red">* </span>Las contraseñas introducidad son diferentes</p>
              <p v-if="errorguardar" class="text-sm mt-2 text-primary-100"><span style="color:red">* </span>Error al guardar la contraseña: {{ this.mensajeError }}</p>
              <p v-if="guardada" class="text-lg mt-2 text-primary-100">Contraseña restablecida!</p>
              <Button @click="onReset()" class="w-full" type="primary">Reestablecer contraseña</Button>
            </div>
          </div>
          <transition name="mailsent">
            <div v-if="mailsent" class="text-center">
              <div class="check-wrap my-8 m-auto"></div>
              <p class="block"> Contraseña cambiada con éxito</p>
            </div>
          </transition>
        </div>
      </div>
    </transition>
    <div class="px-4 w-full z-20 bg-primary-700">
      <router-link :to="{name:'documentList'}" class="w-full flex items-center h-13 hov-arrow-back border-b border-solid border-primary-500">
        <i class="bg-secondary h-6 w-6 flex items-center justify-center rounded transition-200">
          <span class="icon-left text-white text-xs inline-block rounded"></span>
        </i>
        <p class="truncate text-xl sm:text-2xl md:text-3xl font-ligt pl-4">{{name}}</p>
      </router-link>
    </div>
    <div @click="isModified = true" class="h-full flex relative">
      <div :class="{'pb-12': isModified }" class="transition-200 bg-primary-700 flex flex-col lg:flex-row w-full h-full overflow-auto">
        <div class="px-2 pb-4 pt-16 w-full">
          <div class="bg-primary-800 mx-2 mb-4 px-2 py-2 rounded-lg">
            <div class="-mt-16 mb-2 flex items-center">
              <div class="h-30 w-30 overflow-hidden rounded-full border border-solid border-white">
                <img class="transition-200" src="~@/assets/img/test-user.png" alt="">
              </div>
              <div class="ml-4 pb-4">
                <p class="text-light text-lg">{{name}}</p>
                <p class="text-sm">Proveedor</p>
              </div>
            </div>
           <div class="bg-primary-800 mx-2 lg:ml-0 mb-4 px-4 py-2 rounded-lg">
              <p class="text-light text-2xl pb-2">Mis empresas</p>
              <div v-for="(proveedor, index) in proveedores" :key="proveedor" class="py-2 pl-4">
                <span class="text-light block">{{proveedor}}</span>
                <span>{{cifs[index]}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full absolute bottom-0 right-0 overflow-hidden transition-200 flex items-center px-4 global bg-primary-800 h-12 z-10">
      <div class="ml-auto">
        <Button @click="changePwdIsOpen=!changePwdIsOpen" type="primary" size="small" icon="el-icon-check">Reestablecer contraseña</Button>
      </div>
    </div>
  </div>
</template>
<script>
import { Input, Button } from 'element-ui'
import resetPassword from '../utils/portalResetPassword'
import { mapState } from 'vuex'
export default {
  mounted () {
    this.$store.commit('setCIFs')
  },
  computed: {
    ...mapState(['proveedores', 'cifs'])
  },
  components: {
    Button,
    Input
  },
  data () {
    return {
      url: 'https://cdn.filestackcontent.com/wcrjf9qPTCKXV3hMXDwK',
      documentError: undefined,
      enableUploader: process.env.VUE_APP_UPLOAD_ENABLED === 'true',
      name: localStorage.getItem('email'),
      approvalData: [{
        company: 'Lorem dis Delivery',
        location: 'París',
        center: 'Coloma dam bu',
        level: '3'
      }, {
        company: 'Lorem dis Delivery',
        location: 'París',
        center: 'Coloma dam bu',
        level: '2'
      }],
      addContactOpened: false,
      changePwdIsOpen: false,
      npwd: '',
      cnpwd: '',
      mailsent: false,
      errorguardar: false,
      errorpwddif: false,
      errorlen: false,
      mensajeError: '',
      guardada: false
    }
  },

  methods: {
    urlUpdated (url) {
      this.documentError = undefined
      this.url = url
    },
    onDocumentErrored (e) {
      this.documentError = e.text
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (Object.keys(this.multipleSelection).length > 0) {
        this.contactPeopleSelected = true
      } else {
        this.contactPeopleSelected = false
      }
    },
    removeName () {
      if (this.name === 'Nuevo proveedor' || this.name === 'Nombre del proveedor') {
        this.name = ''
      }
    },
    addName () {
      if (this.name === '') {
        this.name = 'Nombre del proveedor'
      }
    },
    addContact () {
      this.addContactOpened = !this.addContactOpened
    },
    addComment () {
      this.addCommentOpened = !this.addCommentOpened
    },
    async onReset () {
      try {
        if (!this.npwd || !this.cnpwd || this.npwd !== this.cnpwd || (this.npwd && this.npwd.length < 8)) {
          this.errorlen = (!this.npwd || !this.cnpwd || this.npwd.length !== 8)
          this.errorpwddif = (this.npwd !== this.cnpwd)
        } else {
          this.errorlen = false
          this.errorpwddif = false
          console.log(localStorage.getItem('email'))
          const { Estado, Mensaje } = await resetPassword(localStorage.getItem('email'), this.npwd)

          if (Estado === 'KO') {
            if (Mensaje === 'Token caducado') {
              alert('Sesión Caducada, por favor, inicie sesión nuevamente')
              localStorage.removeItem('token')
              this.$router.push({ name: 'login' })
            } else {
              this.mensajeError = Mensaje
              this.errorguardar = true
              console.log(Mensaje)
              alert('Se produjo un error al restablecer la contraseña. Por favor, inténtelo nuevamente')
            }
          } else {
            this.mensajeError = ''
            this.errorguardar = false
            this.mailsent = true
          }
        }
      } catch (error) {
        console.log(error.response)
      }
    }
  }
}
</script>
